import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {BenchlingAppSessionMessageStyle} from 'graphql-client/__generated/graphqlGlobalTypes';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {GRAY_DARK} from 'ui-library/Colors';
import {DatetimeTableCell} from 'ui-library/scrollable/table-cells/DatetimeTableCell';

import {GetCanvas} from '../../interactivity/canvases/__generated/GetCanvas';
import {renderChips} from '../../interactivity/sessions/SessionStatusMessage';

type SessionMessageNode = NonNullable<
  ExtractByTypename<GetCanvas['benchlingAppCanvas'], 'BenchlingAppCanvasNode'>['session']
>['messages'][number];

const styles = StyleSheet.create({
  messagesWrapper: {
    marginTop: '32px',
  },
  timestamp: {
    width: 'auto',
    padding: '11px 12px 0px 0px',
    color: GRAY_DARK,
    fontSize: '12px',
    verticalAlign: 'top',
    lineHeight: '16px',
  },
  message: {
    whiteSpace: 'normal',
    width: '100%',
  },
});

const MESSAGE_STYLES: Record<BenchlingAppSessionMessageStyle, string> = {
  [BenchlingAppSessionMessageStyle.NONE]: '',
  [BenchlingAppSessionMessageStyle.INFO]: 'Info: ',
  [BenchlingAppSessionMessageStyle.SUCCESS]: 'Success: ',
  [BenchlingAppSessionMessageStyle.WARNING]: 'Warning: ',
  [BenchlingAppSessionMessageStyle.ERROR]: 'Error: ',
};

export interface SessionMessageTimestampProps {
  timestamp: string;
}

export interface SessionActivityMessageProps {
  message: SessionMessageNode;
}

export function BenchlingAppSessionMessageTimestamp(props: SessionMessageTimestampProps): JSX.Element {
  return (
    <td className={css(styles.timestamp)}>
      <DatetimeTableCell datetime={props.timestamp} showTimeInCell={true} />
    </td>
  );
}

export default function BenchlingAppSessionActivityMessage(props: SessionActivityMessageProps): JSX.Element {
  const icon = MESSAGE_STYLES[props.message.style];
  const content = renderChips(props.message.content);
  return (
    <td className={css(styles.message)}>
      {icon}
      {content}
    </td>
  );
}
